import Facade from "@/Facade";
import {Signals} from "@/Imports"
import Platform from "@base/utils/Platform";
import GameStatesEnum from "@/states/GameStatesEnum";

export default class UIBehaviors {

    popupsEnabled = true;

    constructor () {
        this.isCancel1True = false
        this.isCancel2True = false

        this.isPlaneStarted = false
        this.isTaken1 = false
        this.isTaken2 = false
        Signals.currentBetHasChanged.add(this.onCurrentBetHasChanged, this)
        Signals.currentAutoCollectHasChanged.add(this.onCurrentAutoCollectHasChanged, this)
        Signals.balanceUpdate.add(this.sendBalance, this)
        Signals.stateChanged.add(this.onStateChanged, this)
        Signals.setBetStatus.add(this.onSetBetStatus, this)
        Signals.setMakeBet.add(this.onSetMakeBet, this)
        Signals.betsUpdates.add(this.onBetsUpdates, this)
        Signals.onWin.add(this.onWin, this)
        Signals.roundEnd.add(this.onRoundEnd, this)
        Signals.multipliersHistory.add(this.onMultiplierHistory, this)
        Signals.multiplier.add(this.onMultiplier, this)
        Signals.errorMessage.add(this.onError, this)

        Signals.enableGamePopups.add(this.enablePopups, this)
        Signals.disableGamePopups.add(this.disablePopups, this)

        document.addEventListener("UIIsReady", this.onUIIsReady.bind(this))

        let isMute = !Platform.isMobile()

        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                mute: {
                    visible: isMute,
                    checked: true
                }
            }}))
    }

    onUIIsReady(e) {
        const detail = e.detail
        this.initButtons()
        this.sendBalance(Facade.model.balanceViewText)
        this.showFreeBetsPopup()
        Signals.UIisReady.dispatch()
    }

    showFreeBetsPopup(){
        if(!this.popupsEnabled || Facade.model.freebets == null) return;

        let msg;
        if(Facade.model.freebets.total_amount_given === Facade.model.freebets.amount_left){
            msg = Facade.textFactory.getLocalizedText('freeRoundsPopupText')
                .replace("{0}", Facade.model.freebets.total_amount_given)
                .replace("{1}", Facade.model.freebets.coin_value.toFixed(Facade.model.numbersFixed));
        }else{
            msg = Facade.textFactory.getLocalizedText('freeRoundReconnectPopupText')
                .replace("{0}", Facade.model.freebets.amount_left)
                .replace("{1}", Facade.model.freebets.coin_value.toFixed(Facade.model.numbersFixed));
        }

        const data = {
            "msg": {
                "c": 911,
                "msg": msg,
                "b": "[{\"text\":\"Continue\",\"action\":\"continue\"}]"
            },
            "type": "FREEBETS_NOTIFICATION"
        }

        let event = new CustomEvent("errorMessage", {detail: {value: data}})
        document.dispatchEvent(event)
    }

    hide() {
        const event = new CustomEvent("hide", {})
        document.dispatchEvent(event)
    }

    show() {
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                showTime: true
            }
        }))

        this.showUI()
    }

    showUI() {
        let event = new CustomEvent("show", {})
        document.dispatchEvent(event)
    }

    sendBalance(value) {
        let event = new CustomEvent("setBalance", {detail: {value: value, netBalance: Facade.model.netBalanceViewText}})
        document.dispatchEvent(event)
    }

    onCurrentBetHasChanged(data) {
        const side = data.side
        const value = Number(data.value)
        let event = new CustomEvent("setBet", { detail: {side: side, value: value}})
        document.dispatchEvent(event)
    }

    onCurrentAutoCollectHasChanged(data) {
        const side = data.side
        const value = Number(data.value)
        let event = new CustomEvent("setAutoCollectValue", { detail: {side: side, value: value}})
        document.dispatchEvent(event)
    }


    onStateChanged(state) {
        switch (state) {
            case GameStatesEnum.MAKE_BETS:
                break
        }
    }

    onBetsUpdates(data) {
        let event = new CustomEvent("betsUpdates", { detail: {data: data}})
        document.dispatchEvent(event)
    }

    onWin(data) {
        let event = new CustomEvent("onWin", { detail: {value: data}})
        document.dispatchEvent(event)
    }

    onMultiplierHistory(data) {
        let event = new CustomEvent("multiplierHistory", { detail: {multiplierHistory: data}})
        document.dispatchEvent(event)
    }

    onRoundEnd(data) {
        this.isTaken1 = false
        this.isTaken2 = false
        let event = new CustomEvent("roundEnd", { detail: {finalMultiplier: Facade.model.finalMultiplier}})
        document.dispatchEvent(event)
    }

    onSetMakeBet(side) {
        this.isPlaneStarted = false
        if(side == 1) {
            this.makeBet1()
        }

        if(side == 2) {
            this.makeBet2()
        }
    }

    onMultiplier(data) {
        const amount1 = Facade.model.playerState1.b * data
        const w1 = Facade.model.playerState1.b > 0 ? amount1 : 0

        if(Facade.model.maxWin > 0) {
            if (w1 != '' && amount1 < Facade.model.maxWin) {
                let event1 = new CustomEvent("takeWin1Update", {detail: {value: w1, freebets: Facade.model.currentFreebetsValue}})
                document.dispatchEvent(event1)
            }
        } else {
            let event1 = new CustomEvent("takeWin1Update", {detail: {value: w1, freebets: Facade.model.currentFreebetsValue}})
            document.dispatchEvent(event1)
        }
        const amount2 = Facade.model.playerState2.b * data
        const w2 = Facade.model.playerState2.b > 0 ? amount2 : 0

        if(Facade.model.maxWin > 0) {
            if (w2 != '' && amount2 < Facade.model.maxWin) {
                let event2 = new CustomEvent("takeWin2Update", {detail: {value: w2, freebets: Facade.model.currentFreebetsValue}})
                document.dispatchEvent(event2)
            }
        } else {
            let event2 = new CustomEvent("takeWin2Update", {detail: {value: w2, freebets: Facade.model.currentFreebetsValue}})
            document.dispatchEvent(event2)
        }
    }

    makeBet1() {
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                makeBet1_BUTTON: {
                    enable: true,
                    visible: true
                },
                cancel1_BUTTON: {
                    enable: false,
                    visible: false
                },
                takeWin1: {
                    enable: false,
                    visible: false
                }
            } }))
    }

    makeBet2() {
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                makeBet2_BUTTON: {
                    enable: true,
                    visible: true
                },
                cancel2_BUTTON: {
                    enable: false,
                    visible: false
                },
                takeWin2: {
                    enable: false,
                    visible: false
                }
            } }))
    }

    onSetBetStatus(data) {
        if(data.side == 1) {
            if(data.ps.c) {
                if(Facade.isPlaneStarted) {
                    this.setTakeWin1()
                } else {
                    this.isCancel1True = true
                    this.setCancel1()
                }
            } else {
                this.isCancel1True = true
                this.setCancel1()
            }
        }
        if(data.side == 2) {
            if(data.ps.c) {
                if(Facade.isPlaneStarted) {
                    this.setTakeWin2()
                }
            } else {
                this.isCancel2True = true
                this.setCancel2()
            }
        }
    }
    setCancel1() {
        if(Facade.model.dcb == null || Facade.model.dcb === false) {
            document.dispatchEvent(new CustomEvent("setButtonState", {
                detail: {
                    makeBet1_BUTTON: {
                        enable: false,
                        visible: false
                    },
                    takeWin1: {
                        enable: false,
                        visible: false
                    },
                    cancel1_BUTTON: {
                        enable: true,
                        visible: true
                    }
                }
            }))
        }
    }

    setTakeWin1() {
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                makeBet1_BUTTON: {
                    enable: false,
                    visible: false
                },
                takeWin1: {
                    enable: true,
                    visible: true
                },
                cancel1_BUTTON: {
                    enable: false,
                    visible: false
                }
            } }))
    }

    setCancel2() {
        if(Facade.model.dcb == null || Facade.model.dcb === false) {
            document.dispatchEvent(new CustomEvent("setButtonState", {
                detail: {
                    makeBet2_BUTTON: {
                        enable: false,
                        visible: false
                    },
                    takeWin2: {
                        enable: false,
                        visible: false
                    },
                    cancel2_BUTTON: {
                        enable: true,
                        visible: true
                    }
                }
            }))
        }
    }

    setTakeWin2() {
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                makeBet2_BUTTON: {
                    enable: false,
                    visible: false
                },
                takeWin2: {
                    enable: true,
                    visible: true
                },
                cancel2_BUTTON: {
                    enable: false,
                    visible: false
                }
            } }))
    }

    initButtons() {
        document.dispatchEvent(new CustomEvent("setButtonState", { detail: {
                makeBet1_BUTTON: {
                    enable: true,
                    visible: true
                },
                makeBet2_BUTTON: {
                    enable: true,
                    visible: true
                },
                takeWin1: {
                    enable: false,
                    visible: false
                },
                cancel1_BUTTON: {
                    enable: false,
                    visible: false
                },
                takeWin2: {
                    enable: false,
                    visible: false
                },
                cancel2_BUTTON: {
                    enable: false,
                    visible: false
                }
            } }))

        if(this.isCancel1True) {
            this.isCancel1True = false
            this.setCancel1()
        }
        if(this.isCancel2True) {
            this.isCancel2True = false
            this.setCancel2()
        }
    }

    enablePopups() {
        this.popupsEnabled = true;
    }

    disablePopups() {
        this.popupsEnabled = false;
    }

    onError(data) {
        if(!this.popupsEnabled) return;
        
        const msg = data.msg
        const type = data.type
        let event = new CustomEvent("errorMessage", {detail: {value: data}})
        document.dispatchEvent(event)

        setTimeout(() => Facade.model.updateState(), 100)
    }
}
